enum LaunchState {
	SUCCESS = 'success',
	FAILURE = 'failure',
}

type LaunchResponse = {
	status: LaunchState;
	errorId?: string;
	errorMessage?: string;
};

function parseLaunchResponse(
	launchResponse: LaunchResponse | string | void
): LaunchResponse {
	const successResponse = { status: LaunchState.SUCCESS };
	if (!launchResponse) {
		return successResponse;
	}
	if (typeof launchResponse === 'string') {
		try {
			// Historically, the launch response was either a string(success, failure), null, undefined
			// With new CWA, we have requested the response to be a stringified JSON object with status and errorId
			// If this is not a valid JSON, we will assume it to be a older response and handle it as a string response
			return JSON.parse(launchResponse);
		} catch {
			return { status: launchResponse as LaunchState };
		}
	}
	return launchResponse;
}

export function handleCWALaunchError(
	launchResponse: LaunchResponse | string | void
): void {
	const response = parseLaunchResponse(launchResponse);

	if (response.status === LaunchState.FAILURE) {
		const error = new Error(response.errorId || 'Unknown error');
		error.name = 'CvadLaunchFailure';
		throw error;
	}
}
